'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LikertLegend = exports.LikertKey = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colorsPatterns = require('./colorsPatterns');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var d3 = require('d3');

var defaultOptions = {
  colors: _colorsPatterns.defaultColors,
  usePatterns: true,
  continuous: false

  // simpler component for legend box
};
var LikertKey = exports.LikertKey = function (_React$Component) {
  _inherits(LikertKey, _React$Component);

  function LikertKey(props) {
    _classCallCheck(this, LikertKey);

    var _this = _possibleConstructorReturn(this, (LikertKey.__proto__ || Object.getPrototypeOf(LikertKey)).call(this, props));

    _this.updateChart = _this.updateChart.bind(_this);
    return _this;
  }

  _createClass(LikertKey, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        return _this2.updateChart();
      }, 100);
    }
  }, {
    key: 'updateChart',
    value: function updateChart() {
      var _props = this.props,
          index = _props.index,
          total = _props.total,
          scale = _props.scale,
          width = _props.width,
          height = _props.height,
          options = _props.options;

      var useOptions = _extends({}, defaultOptions, options || {});
      var colors = useOptions.colors;
      var usePatterns = useOptions.usePatterns;

      // reset
      this.svg.innerHTML = null;
      this.svg.setAttribute('width', 0);
      var n = total || scale.length;

      var useColors = colors || _colorsPatterns.defaultColors;

      var boxWidth = this.div.getBoundingClientRect().width;
      var boxHeight = this.div.getBoundingClientRect().height;
      var svg = d3.select(this.svg).attr('width', width);

      var pattern = usePatterns ? useOptions.continuous ? (0, _colorsPatterns.getFillContinuous)(n, index, useColors) : (0, _colorsPatterns.getFill)(n, index, useColors) : useOptions.continuous ? (0, _colorsPatterns.getColorContinuous)(n, index, useColors) : (0, _colorsPatterns.getColor)(n, index, useColors);

      if (usePatterns) svg.call(pattern);

      svg.append('rect').attr('height', height || boxHeight).attr('width', width || boxWidth).attr('x', 0).attr('y', 0).attr('fill', usePatterns ? pattern.url() : pattern);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          height = _props2.height,
          width = _props2.width,
          style = _props2.style;

      return _react2.default.createElement(
        'div',
        { ref: function ref(elem) {
            _this3.div = elem;
          }, style: style || {} },
        _react2.default.createElement('svg', { ref: function ref(elem) {
            _this3.svg = elem;
          }, height: height || 0, width: width || 0 })
      );
    }
  }]);

  return LikertKey;
}(_react2.default.Component);

var LikertLegend = exports.LikertLegend = function LikertLegend(_ref) {
  var scale = _ref.scale,
      options = _ref.options,
      inline = _ref.inline,
      size = _ref.size,
      style = _ref.style;
  return _react2.default.createElement(
    'div',
    { style: style || {} },
    scale.map(function (choice, i) {
      return (
        // loop through scale, draw box / label for each
        _react2.default.createElement(
          'div',
          {
            key: choice,
            style: {
              display: inline ? 'inline-block' : 'block',
              fontSize: (size || 15) + 'px',
              paddingLeft: '1em'
            }
          },
          _react2.default.createElement(LikertKey, {
            scale: scale,
            options: options,
            index: i,
            height: size || 15,
            width: size || 15,
            style: { display: 'inline-block' }
          }),
          '\xA0 ',
          choice
        )
      );
    })
  );
};


//////////////////
// WEBPACK FOOTER
// ./~/react-likert/lib/components/visualizations/LikertLegend.js
// module id = 770
// module chunks = 168707334958949